import surgicalApproaches, { SurgicalApproaches } from '../Enums/SurgicalApproaches';

const logScaleEstimates = [
  -3.104991, // intercept
  0.003830, // age
  0.375949, // previous caesarian
  0.588184, // surgical approach open
  -0.500752, // surgical approach vaginal
  0.433269, // preop anemia
  0.207405, // asa class 2
  0.531009, // asa class 3
  1.230707, // asa class 4
  0.709767, // asa class 5
  0.313111, // suspected endometriosis
  0.229547, // suspected adhesions
];

const convertBool = (boolVal: boolean) : number => (boolVal ? 1 : 0);

const convertAnemia = (anemiaVal: number) : number => (anemiaVal >= 120 ? 0 : 1);

const detectApproach = (approach: SurgicalApproaches, approachName: string) : number => (
  convertBool(surgicalApproaches.find((sa) => sa === approachName) === approach)
);

const buildVector = (age : number, caesarian : boolean, approach : SurgicalApproaches, asa : number,
  anemia : number, endo : boolean, adhesion : boolean) : number[] => ([
  1,
  age,
  convertBool(caesarian),
  detectApproach(approach, 'Open'),
  detectApproach(approach, 'Vaginal'),
  convertAnemia(anemia),
  convertBool(asa === 2),
  convertBool(asa === 3),
  convertBool(asa === 4),
  convertBool(asa === 5),
  convertBool(endo),
  convertBool(adhesion),
]);

const calculateOdds = (age : number, caesarian : boolean, approach : SurgicalApproaches,
  asa : number, anemia : number, endo : boolean, adhesion : boolean) : number => {
  const vector = buildVector(age, caesarian, approach, asa, anemia, endo, adhesion);
  const dotProduct = logScaleEstimates.reduce(
    (acc, predictor, index) => acc + predictor * vector[index], 0,
  );
  const odds = Math.exp(dotProduct);

  return Math.round((odds / (odds + 1)) * 100);
};

const complicationPrediction = (age : number, caesarian : boolean, approach : SurgicalApproaches,
  asa : number, anemia : number, endo : boolean, adhesion : boolean):
{ primary: number, secondary: number | null } => {
  const primaryOdds = calculateOdds(age, caesarian, approach, asa, anemia, endo, adhesion);
  const secondaryOdds = convertAnemia(anemia)
    ? calculateOdds(age, caesarian, approach, asa, 121, endo, adhesion)
    : null;

  return {
    primary: primaryOdds,
    secondary: secondaryOdds,
  };
};

export default complicationPrediction;
